/**
 * Takes an observable and a resolver for the initial (current) value and maps it into the
 * `TFeatureView` type.
 */
var createViewFromObservable = function (observable, getCurrentValue) { return ({
    update$: observable,
    getCurrentValue: getCurrentValue,
    get first() {
        return getCurrentValue();
    },
}); };
export { createViewFromObservable };
//# sourceMappingURL=createViewFromObservable.js.map